// #region imports
import React, { FC } from 'react';
import cn from 'classnames';

import { useTranslation } from 'react-i18next';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import styles from './styles';
import useMobile from 'hooks/useMobile';
import { PRIZES } from 'configs/constants';
import { ReactComponent as TengeSvg } from 'assets/svg/tenge.svg';
import { ReactComponent as CupSvg } from 'assets/svg/cup.svg';
import Typography from '@mui/material/Typography';

// #endregion

interface IProps {
  className?: string;
  currentNumber: number;
}

const PrizeFondTable: FC<IProps> = ({
  className,
  currentNumber
}) => {

  const classes = styles();
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  return (
    <TableContainer className={ cn(className, classes.root) }>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              { !isMobile &&
                <Typography className={ classes.superPrizeLabel }>{ t('prizeFond.label.superPrize') }</Typography>
              }
              <Typography className={ classes.superPrize }>1 000 000 ₸</Typography>
            </TableCell>
            <TableCell className={ classes.winerCell } align={ isMobile ? 'right' : 'left' }>
              { isMobile
                ? t('prizeFond.label.superPrize')
                : t('prizeFond.label.superPrizeCount')
              }
            </TableCell>

          </TableRow>
          { PRIZES[currentNumber].map(({ count, price }, index) => (
            <TableRow key={ `${currentNumber}-${index}` }>
              <TableCell>
                <div className={ classes.price }>
                  <TengeSvg /> <span>{ price } ₸</span>
                </div>
              </TableCell>
              <TableCell className={ classes.winerCell } align={ isMobile ? 'right' : 'left' }>
                { count } { t('label.win') }
              </TableCell>
              { !isMobile &&
                <TableCell align="right">
                  <CupSvg/>
                </TableCell>
              }
            </TableRow>
          )) }
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PrizeFondTable;
